import loadable from '@loadable/component';

const Marker = loadable(() => import('../components/google-maps/AdvancedMarker'), {
  resolveComponent: (m) => m.AdvancedMarker,
});

const GoogleMarkerClusterer = loadable(() => import('@react-google-maps/api'), {
  resolveComponent: (m) => m.GoogleMarkerClusterer,
});

const OverlayViewF = loadable(() => import('@react-google-maps/api'), { resolveComponent: (m) => m.OverlayViewF });

const Polyline = loadable(() => import('@react-google-maps/api'), { resolveComponent: (m) => m.Polyline });

const GoogleMap = loadable(() => import('@react-google-maps/api'), { resolveComponent: (m) => m.GoogleMap });

const MapWrapper = loadable(() => import('../components/google-maps/MapWrapper'));

export { Marker, GoogleMap, MapWrapper, GoogleMarkerClusterer, OverlayViewF, Polyline };
